<div class="page-root">
  @if (mode == 'mobile') {
    <div class="page-one-column-body">
      <div class="flex">
        <div class="root-column">
          <app-logo/>
          <router-outlet/>
        </div>
      </div>
    </div>
  } @else {
    @if (appointmentSelectionService.timeSlotModels.length > 0) {
      @if (mode == 'desktop') {
        <div class="page-three-column-body">
          <div class="root-row">
            <div class="flex">
              <div class="column">
                <app-logo/>
                @if(isManager){
                  <app-patient-search />
                }
                <app-appointment-filters [mobile]="false"/>
              </div>
            </div>

            <mat-divider class="primary" vertical/>

            <div class="flex">
              <app-date-selection [mobile]="false"/>
            </div>

            <mat-divider class="primary" vertical/>

            <app-time-selection [mobile]="false" class="time-selection"/>
          </div>
        </div>
      } @else {
        <div class="page-two-column-body">
          <div class="root-row-tablet">
            <div class="flex">
              <div class="column">
                <app-logo/>
                @if(isManager){
                  <app-patient-search />
                }
                <app-appointment-filters [mobile]="false"/>
              </div>
            </div>

            <mat-divider class="primary" vertical/>

            <div class="flex">
              <div class="column">
                <app-date-selection [mobile]="false"/>

                <mat-divider class="primary"/>

                <app-time-selection [mobile]="false"/>
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="page-two-column-body">
        <div class="root-row">
          <div class="flex">
            <div class="column">
              <app-logo/>
              @if(isManager){
              <app-patient-search />
              }
              <app-appointment-filters [mobile]="false"/>
            </div>
          </div>

          <mat-divider class="primary" vertical/>

          <div class="flex">
            <app-date-selection [mobile]="false"/>
          </div>
        </div>
      </div>
    }
  }
</div>
